import React from 'react';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MuiAlert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';
import iconRequestSent from '../../images/support.svg';
import hdLogoWide from '../../images/logo.svg';
import DefaultInput from '../../customUI/DefaultInput';
import PrimaryButton from '../../customUI/PrimaryButton';
import PrimaryContainer from '../../customUI/PrimaryContainer';
import MobileTitle from '../../customUI/MobileTitle';
import theme from '../../theme';

const { REACT_APP_FLASK_API_URL } = process.env;

function Alert(props) {
  // eslint-disable-next-line
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(() => ({
  wrapper: {
    margin: 30,
  },
  container: {
    padding: '25px 24px',
  },
  flex_container: {
    display: 'flex',
    margin: '100px 0',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      margin: '50px 0',
    },
    background: 'white',
    flexGrow: 1,
    height: '100%',
    justifyContent: 'top',
    alignItems: 'center',
    textAlign: 'center',
    alignContent: 'center',
    padding: 30,
  },
  flex_child: {
    flex: 1,
    flexGrow: 1,
    textAlign: 'center',
    '& h1': {
      fontSize: 66,
      color: '#03B5E1',
      fontWeight: 500,
      maxWidth: 300,
      margin: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      fontFamily: 'Playfair Display',
    },
    '& p': {
      fontSize: 15,
      color: '#818181',
      fontWeight: 500,
      lineHeight: '24px',
      maxWidth: 400,
      margin: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  colorPrimary: {
    backgroundColor: '#E5E5E5',
  },
  barColorPrimary: {
    backgroundColor: '#00B5E2',
  },
  heading: {
    padding: '0 0 10px 16px',
    fontSize: '2.125rem',
  },
  image: {
    flex: 1,
    width: 67,
  },
  imageLogo: {
    flex: 1,
    width: '50%',
    marginTop: 70,
  },
  submitButton: {
    width: '50%',
    backgroundColor: '#00B5E2',
  },
  supportForm: {
    margin: 20,
    marginBottom: 0,
    maxWidth: 450,
    '& .MuiFormControl-root': {
      marginBottom: 20,
      width: '100%',
      maxWidth: 400,
    },
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const Support = () => {
  const classes = useStyles();
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const [submitButtonResponse, changeSubmitButtonResponse] = React.useState('');
  const [details, ChangeDetails] = React.useState('');
  const [product, ChangeProduct] = React.useState('');
  const [openNotification, setOpenNotification] = React.useState(false);
  const [statusNotification, setStatusNotification] = React.useState('success');

  window.scrollTo(0, 0);
  const handleNotificationClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenNotification(false);
  };

  const handleChangeProduct = (e) => {
    ChangeProduct(e.target.value);
  };

  const handleSubmitButton = () => {
    const data = {
      message_subject: product,
      message_body: details,
      cc: 'xronis@hennessey.com',
      template_name: 'support_request',
    };

    axios.post(`${REACT_APP_FLASK_API_URL}/v1/chat`, data).then((res) => {
      if (res.data.success) {
        changeSubmitButtonResponse(res.data.message);
        setOpenNotification(true);
        setStatusNotification('success');
      }
      if (res.data.error) {
        changeSubmitButtonResponse(res.data.message);
        setOpenNotification(true);
        setStatusNotification('error');
      }
    });
  };

  return (
    <>
      {isPhone && <MobileTitle title="Support" />}
      <PrimaryContainer className={classes.container}>
        <div className={classes.flex_container}>
          <div className={classes.flex_child}>
            <h1>How Can We Help?</h1>
            <p>
              Send us a message by filling out the form. We move fast, so expect to hear from us
              quickly
            </p>
            <img src={hdLogoWide} alt="" className={classes.imageLogo} />
          </div>
          <div className={classes.flex_child}>
            <div className="App">
              <img src={iconRequestSent} alt="iconRequestSent" className={classes.image} />
            </div>
            <br />
            <form className={classes.supportForm} noValidate>
              <TextField
                fullWidth
                label="Product"
                variant="outlined"
                value={product}
                onChange={handleChangeProduct}
                data-testid="product_test_id"
                select
              >
                <MenuItem key={1} value="Leads">
                  Leads
                </MenuItem>
                <MenuItem key={2} value="Content">
                  Content
                </MenuItem>
                <MenuItem key={3} value="Analytics">
                  Analytics
                </MenuItem>
                <MenuItem key={4} value="Other">
                  Other
                </MenuItem>
              </TextField>

              <DefaultInput
                rows={5}
                multiline
                label="Details"
                variant="outlined"
                value={details}
                data-testid="details_test_id"
                type="text"
                onChange={(e) => {
                  ChangeDetails(e.target.value);
                }}
              />
              <PrimaryButton
                onClick={handleSubmitButton}
                variant="contained"
                color="primary"
                data-testid="submit_button_test_id"
                className={classes.submitButton}
              >
                Submit
              </PrimaryButton>
            </form>

            <Snackbar
              open={openNotification}
              autoHideDuration={6000}
              onClose={handleNotificationClose}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              key="bottom left"
            >
              {statusNotification === 'success' ? (
                <Alert onClose={handleNotificationClose} severity="success">
                  Support email sent {submitButtonResponse}
                </Alert>
              ) : (
                <Alert onClose={handleNotificationClose} severity="error">
                  Support email not sent, please try again. {submitButtonResponse}
                </Alert>
              )}
            </Snackbar>
          </div>
        </div>
      </PrimaryContainer>
    </>
  );
};

export default Support;
